const defaultState = {
  loading: false,
  labels: {
    "Loan Account": "",
    "Loan Number": "",
    "Borrowers": "",
    "Borrower’s Chat": "",
    "Export Borrowers list": "",
    "ACCOUNT NUMBER" : "",
    "Link Accounts" : "",
    "Lender Chat" : "",
    "Account Details" : "",
    "Last Payment" : "",
    "Next Payment" : "",
    "Total Payable" : "",
    "No scheduled payments" : "",
    "LINK ACCOUNT" : "",
    "Social Security Number" : "",
    "Social Security Number Four" : "",
    "Branch Number" : "",
    "DOB" : "DOB",
    "Postal Code" : "",
    "Phone Number" : "",
    "First Name" : "First Name",
    "Payment Options" : "Payment Options",
    "Change Password" : "Change Password",
    "Contact Information" : "Contact Information",
    "schedule a payment" : "schedule a payment",
    "Schedule Date" : "Schedule Date",
    "Schedule Date 2" : "Schedule Date 2",
    "Payment Frequency" : "Payment Frequency",
    "SORT BY" : "SORT BY",
    "CARD" : "CARD",
    "CHECK" : "CHECK",
    "Payment Type" : "Payment Type",
    "Street Number and Name" : "Street Number and Name",
    "Unit Number" : "Unit Number",
    "State" : "State",
    "City" : "City",
    "Zipcode" : "Zipcode",
    "EMAIL ADDRESSES" : "Email Addresses",
    "Add Card Title" : "Add Card",
    "Add Card Description" : "Please provide the information below to make payments using your bank card.",
    "Add Bank Account Title" : "Add Bank Account",
    "Add Bank Account Description" : "Please provide the information below to make payments using your bank account.",
    "Add Bank Account (CA) Title" : "Add Bank Account (CA)",
    "Add Bank Account (CA) Description" : "Please provide the information below to make payments using your bank account.",
    "Routing (ABA) Number" : "Routing (ABA) Number",
    "Full Name" : "Full Name",
    "Account Type" : "Account Type",
    "Bank Nickname" : "Bank Nickname",
    "Billing Zip" : "Billing Zip",
    "CVC" : "CVC",
    "Expiration Date" : "Expiration Date",
    "Card Number" : "Card Number",
    "Name" : "Name",
    "Bank Account (CA)" : "Bank Account (CA)",
    "Bank Account" : "Bank Account",
    "Bank Account Number" : "Bank Account Number",
    "Pay" : "Pay",
    "Add New Payment Method": "Add New Payment Method",
    "Status" : "STATUS",
    "Convenience Fee": "Convenience Fee"
  }
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'loading-config':
      return { ...state, loading: true }
    case 'loading-config-finish':
      var mergeState = {...state.labels, ...action.payload};
      return { ...state, labels: mergeState, loading: false }
    case 'loading-config-error':
      return { ...state, error: action.error }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/white-label.js